import axios from 'axios';

export default function estimateTax(data) {
  const url = `${window.location.origin}/api/estimates/estimateSummary`;

  return axios.post(url, data);
}
